module.exports = __webpack_public_path__ + "img/f585fc1.png";